import React from 'react';
import './contact.css';

const ContactPage = () => (
  <section className="contact-page" aria-labelledby="contact-title">
    <div className="container">
      <h1 id="contact-title">We would love to hear from you.</h1>
      <p className="contact-intro">Have a project in mind? Let's discuss what you need and how we can help.</p>
      <a className="contact-booking" href="https://calendly.com/arber-shabani/30min" target="_blank" rel="noopener noreferrer">
        <span className="material-icons" aria-hidden="true">calendar_today</span>
        Book a 30-minute call
        <span className="material-icons" aria-hidden="true">north_east</span>
      </a>
      <p className="contact-scheduler">Calendly with Arbër Shabani</p>
      <div className="contact-details">
        <div>
          <h2>Get in touch</h2>
          <ul>
            <li><a href="mailto:arber@coetic-x.com">arber@coetic-x.com</a></li>
            <li><a href="tel:+38345250180">+383 45 250 180</a></li>
            <li>Ferid Curri, Prishtina 10000, Kosovo</li>
          </ul>
        </div>
        <div>
          <h2>Follow our work</h2>
          <ul>
            <li><a href="https://www.linkedin.com/company/coeticx" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
            <li><a href="https://www.instagram.com/coeticx/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default ContactPage;
